// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"20":"299f6d82","232":"299f6d82","466":"299f6d82","925":"7d209919"}[chunkId] + ".chunk.css";
};